import apiClient from '@/services/apiClient';
import { toast } from 'sonner';

export const fmtQ = (q) => String(Math.round((Number(q) || 0) * 1000) / 1000);
export const errMsg = (e, fallback) => e?.response?.data?.detail || fallback;
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString('en-IN', {
  timeZone: 'Asia/Kolkata', day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
}) : '');
export const REASON_OPTIONS = [
  ['EXCESS', 'Excess / not ordered'], ['WRONG_ITEM', 'Wrong item or colour'], ['DAMAGED', 'Damaged / quality reject'], ['OTHER', 'Other'],
];

const greigeItem = (r) => ({
  key: r.bundle_barcode, ref: { bundle_barcode: r.bundle_barcode }, kind: 'bundle', title: r.bundle_barcode, splitFrom: r.split_from,
  sortNo: r.sort_no, design: r.design_name, color: r.color_name, stage: r.stage, location: r.location, qtyNow: r.qty_now,
  max: r.returnable, fixed: r.whole_only && r.qty_known ? r.qty_now : null, canReturn: r.can_return, note: r.note,
  po: r.po, poList: r.po ? [r.po] : [], returned: r.returned_qty,
});

const fobSortItem = (s) => ({
  key: `sort:${s.sort_no}`, ref: { sort_no: s.sort_no }, kind: 'sort', title: `Sort ${s.sort_no}`, sortNo: s.sort_no,
  design: s.design_name, color: s.color_name, stage: `${fmtQ(s.in_stock_qty)} not packed · ${fmtQ(s.packed_qty)} packed · ${s.bundle_count} bundle(s)`,
  qtyNow: s.in_stock_qty, max: s.returnable, fixed: null, canReturn: s.can_return, note: s.note, poList: s.po, noPo: s.no_po_qty,
  returned: s.returned_qty,
});

const fobBundleItem = (b) => ({
  key: b.bundle_barcode, ref: { bundle_barcode: b.bundle_barcode }, kind: 'bundle', title: b.bundle_barcode, stage: 'Not tagged yet',
  qtyNow: null, max: null, fixed: null, canReturn: b.can_return, note: b.note, poList: [],
});

export const toItems = (d) => (d.section === 'Greige'
  ? (d.rows || []).map(greigeItem)
  : [...(d.sorts || []).map(fobSortItem), ...(d.bundles || []).map(fobBundleItem)]);

// Greige: how much of each PO line's above-PO allowance the typed qtys use.
export const poUsage = (items, picks) => items.reduce((u, it) => {
  const q = Number(picks[it.key]?.qty) || 0;
  if (q > 0 && it.po) u[it.po.po_item_id] = (u[it.po.po_item_id] || 0) + (it.po.pcs ? q : it.po.counted_qty);
  return u;
}, {});

const readBlobError = async (data) => {
  try { const t = await data.text(); return JSON.parse(t).detail || t.slice(0, 200); } catch (_) { return ''; }
};

export async function downloadChallan(ret) {
  try {
    const r = await apiClient.get(`/supplier-returns/${ret.return_id}/challan`, { responseType: 'blob' });
    const blob = r.data.type ? r.data : new Blob([r.data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.target = '_blank'; a.rel = 'noopener';
    a.download = `Return_Challan_${ret.return_no.replace(/\//g, '-')}.pdf`;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    const detail = e.response?.data instanceof Blob ? await readBlobError(e.response.data) : errMsg(e, '');
    toast.error(detail || 'Could not get the Return Challan');
  }
}
